import { push } from 'connected-react-router';
import { actions } from '../../../store/actions';

export const thxForSubscribe = () => dispatch => {
  dispatch(actions.closeModal.act('thxForSubscribe'));
  localStorage.removeItem('isUserAdult');
  dispatch(push('/check-age'));
};
